import React from 'react';
import { twMerge } from 'tailwind-merge';
/* eslint-disable-next-line */
export interface SwitchProps {
    ref?: React.Ref<HTMLInputElement> | null;
    id: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    disabled?: boolean;
    className?: string;
    checked?: boolean;
}

export function Switch(props: SwitchProps) {
    const classes = twMerge(
        'w-8 h-4 relative bg-gray-50 hover:bg-gray-100 checked: border-2 border-white active:border-primary-100 rounded-full shadow-inner box-content peer-checked:bg-primary',
        props.disabled && 'hover:bg-gray-50',
    );
    const classesSwitch = twMerge(
        'before:absolute before:h-[14px] before:w-[14px] before:top-px before:left-px before:rounded-full before:bg-white peer-checked:before:translate-x-[16px] before:transition-transform',
        props.disabled && 'before:bg-gray-100',
    );
    return (
        <div className={twMerge('flex', props.className)}>
            <input
                ref={props.ref}
                id={props.id}
                name={props.id}
                role="switch"
                type="checkbox"
                className="hidden peer"
                onChange={props.onChange}
                disabled={props.disabled}
                checked={props.checked}
            />
            <label
                htmlFor={props.id}
                className={`${classes} ${classesSwitch}`}
                data-test-id={'test-switch-' + props.id}
            />
        </div>
    );
}

export default Switch;
